import React from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { SOCIETY_MANAGEMENT, SOCIETY_MANAGEMENT_CREATE } from "../../../Routing/routes";
import FormValidationLayer from "./Component/FormValidationLayer";

const CreateSocietyMangement = () => {
    const links = [{ to: SOCIETY_MANAGEMENT, text: 'Community Management' }, { to: SOCIETY_MANAGEMENT_CREATE, text: 'Create' }]
    return (
        <>
            <Breadcrumb replaceClass="mb-24" links={links} headingTitle="Create Community" />
            <FormValidationLayer />
        </>
    );
};

export default CreateSocietyMangement;
